import { BrowserRouter, Route, Routes, useParams } from "react-router-dom"
import Auth from "../scenes/Auth/Auth"
import AppLayout from "../layouts/AppLayout"
import NotFound from "../components/ErrorPages/NotFound"
import AuthLayout from "../layouts/AuthLayout"
import Dashboard from "../scenes/Dashboard/Dashboard"
import { ROUTES } from "../services/constants"
import { ProtectedRoute } from "./ProtectedRoute"
import { useTranslation } from "react-i18next"
import Search from "../scenes/Search/Search"
import { RoleRoute } from "./RoleRoute"
import Users from "../scenes/Users/Users"
import Payments from "../scenes/Payments/Payments"
import MasterLayout from "../layouts/MasterLayout"
import { Invoices } from "../scenes/Invoices/Invoices"
import Stats from "../scenes/Stats/Stats"
import PaymentStats from "../scenes/Stats/PaymentStats"
import Monitoring from "../scenes/Monitoring/Monitoring"


export const AppRoutes = () => {
    const {t} = useTranslation();
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<MasterLayout />}>
                    <Route element={<AuthLayout />}>
                        <Route path={ROUTES.AUTH_ROUTE} element={<Auth />} /> 
                    </Route>
                    <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                        <Route path={ROUTES.DASHBOARD} element={<Dashboard />} /> 
                        <Route path={ROUTES.ALL_USERS} element={<Users />} /> 
                        <Route path={ROUTES.PENDING_APPROVAL_PAYMENTS} element={<Payments status={"0"} method={2} key={0}/>} /> 
                        <Route path={ROUTES.PAYMENTS} element={<Payments title={t("Payments")} key={1}/>} /> 
                        <Route path={ROUTES.INVOICES} element={<Invoices/>} /> 
                        <Route path={ROUTES.REPORTS_STATS} element={<Stats/>} /> 
                        <Route path={ROUTES.REPORTS_PAYMENTS} element={<PaymentStats/>} /> 
                        <Route path={ROUTES.MONITORING} element={<Monitoring/>} /> 
                        
                        
                        
                    </Route>
                    <Route path="/account/:uid" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                        <Route path={ROUTES.ACCOUNT_DASHBOARD} element={<Dashboard />} /> 
                        <Route path={ROUTES.ACCOUNT_PENDING_APPROVAL_PAYMENTS} element={<Payments status={"0"} method={2} key={0}/>} /> 
                        <Route path={ROUTES.ACCOUNT_PAYMENTS} element={<Payments title={t("Payments")} key={1}/>} /> 
                        <Route path={ROUTES.ACCOUNT_INVOICES} element={<Invoices />} /> 
                        <Route path={ROUTES.ACCOUNT_REPORTS_STATS} element={<Stats/>} /> 
                        <Route path={ROUTES.ACCOUNT_REPORTS_PAYMENTS} element={<PaymentStats/>} /> 
                        <Route path={ROUTES.ACCOUNT_MONITORING} element={<Monitoring/>} /> 
                    </Route>
                    <Route path={"*"} element={<NotFound />} /> 
                </Route>
                
            </Routes>
        </BrowserRouter>
        
    )
}